import { useState, useEffect } from "react";
import { Table, Button, Container, Form, ListGroup, Card, Row, Col } from 'react-bootstrap';
import axios from "axios";
import { Actividad } from "../types/Actividad";
import { Empresa } from "../types/Empresa";
import { Contact } from "../types/Contact";
import { api } from '../services/api';

const API_URL = process.env.REACT_APP_API_URL;

export default function BusquedaActividadPage() {

    const [ciiuQuery, setCiiuQuery] = useState('');
    const [ciiuOptions, setCiiuOptions] = useState<Actividad[]>([]);
    const [selectedCiiu, setSelectedCiiu] = useState<Actividad | null>(null);

    useEffect(() => {
    if (ciiuQuery.length < 2) return;

    const fetchData = async () => {
        const res = await axios.get<Actividad[]>(`${API_URL}/ciiu-autocomplete`, {
        params: { q: ciiuQuery }
        });
        setCiiuOptions(res.data);
    };

    fetchData();
    }, [ciiuQuery]);

    // Empresas
    const [empresas, setEmpresas] = useState<Empresa[]>([]);
    const [loadingEmpresas, setLoadingEmpresas] = useState(false);
    const [pageEmp, setPageEmp] = useState(1);
    const pageSizeEmp = 20;

    useEffect(() => {
        if (!selectedCiiu) return;

        const fetchEmpresas = async () => {
            const res = await axios.get<Empresa[]>(`${API_URL}/empresas-por-ciiu`, {
            params: { 
                codigo: selectedCiiu.codigo,
                page: pageEmp,
                page_size: pageSizeEmp                
            }
            });
            setEmpresas(res.data);
            setLoadingEmpresas(false);
        };

        fetchEmpresas();
    }, [selectedCiiu, pageEmp]);

    // Contactos
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState<Empresa | null>(null);
    const [contactosEmpresa, setContactosEmpresa] = useState<Contact[]>([]);
    const [loadingContactos, setLoadingContactos] = useState(false);
    const [pageCont, setPageCont] = useState(1);
    const pageSizeCont = 20;        

    useEffect(() => {
    if (!empresaSeleccionada) return;

    const fetchContactos = async () => {
        const res = await api.get<Contact[]>(`${API_URL}/contactos-empresa`, {
        params: { 
            ruc: empresaSeleccionada.numero_ruc,
            page: pageCont,
            page_size: pageSizeCont            
        }
        });
        setContactosEmpresa(res.data);
        setLoadingContactos(false);
    };

    fetchContactos();
    }, [empresaSeleccionada, pageCont]);

    return (
    <div>
      <h2 className="mb-4">Contactos por Actividad</h2>
        <Card className="mb-4">
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Actividad Económica (CIIU)</Form.Label>
                            <Form.Control
                                value={ciiuQuery}
                                onChange={(e) => setCiiuQuery(e.target.value)}
                                placeholder="Buscar por código o descripción"
                            />

                            {ciiuOptions.length > 0 && (
                                <ListGroup className="autocomplete-list">
                                {ciiuOptions.map((item) => (
                                    <ListGroup.Item
                                    key={item.id}
                                    action
                                    onClick={() => {
                                        setSelectedCiiu(item);
                                        setPageEmp(1);
                                        setCiiuQuery(item.codigo + " - " + item.descripcion);
                                        setCiiuOptions([]);
                                    }}
                                    >
                                    <strong>{item.codigo}</strong> — {item.descripcion}
                                    </ListGroup.Item>
                                ))}
                                </ListGroup>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>     

      {/* Tabla */}
      <Card>
        <Card.Header><strong>Empresas</strong></Card.Header>
            {loadingEmpresas && (
                <div className="text-center py-3">Cargando empresas...</div>
            )} 

            {!loadingEmpresas && empresas.length === 0 && (
                <div className="text-center py-3 text-muted">
                No se encontraron empresas
                </div>
            )}

            {!loadingEmpresas && empresas.length > 0 && (
                <>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>RUC</th>
                            <th>Razón Social</th>
                            <th>Teléfono</th>
                            <th>Correo</th>
                            <th>Dirección</th>
                            <th>Provincia</th>
                            <th>Cantón</th>
                            <th>CIIU</th>
                            <th>Actividad</th>
                            </tr>
                        </thead>
                        <tbody>
                        {empresas.map((e) => (
                            <tr key={e.numero_ruc} onClick={() => setEmpresaSeleccionada(e)}>
                            <td>{e.numero_ruc}</td>
                            <td>{e.razon_social}</td>
                            <td>{e.telefono}</td>
                            <td>{e.correo_electronico}</td>
                            <td>{e.direccion}</td>
                            <td>{e.provincia}</td>
                            <td>{e.canton}</td>
                            <td>{e.actividad_economica_principal}</td>
                            <td>{e.actividad}</td>
                            </tr>
                        ))}
                        </tbody>                        
                    </Table>

                    {/* PAGINACIÓN */}
                    <div className="d-flex justify-content-between p-3">
                        <Button
                        variant="outline-primary"
                        disabled={pageEmp === 1}
                        onClick={() => setPageEmp(pageEmp - 1)}
                        >
                        ← Anterior
                        </Button>

                        <span>Página {pageEmp}</span>

                        <Button
                        variant="outline-primary"
                        onClick={() => setPageEmp(pageEmp + 1)}
                        >
                        Siguiente →
                        </Button>
                    </div>                    
                </>
            )}
        </Card>

        {empresaSeleccionada && (
        <Card className="mt-4">
            <Card.Header>
                Contactos de {empresaSeleccionada.razon_social}
            </Card.Header>

            {loadingContactos && (
                <div className="text-center py-3">Cargando contactos...</div>
            )}

            {!loadingContactos && contactosEmpresa.length === 0 && (
                <div className="text-center py-3 text-muted">
                    No se encontraron contactos
                </div>
            )}

            {!loadingContactos && contactosEmpresa.length > 0 && (
                <>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>Identificación</th>
                            <th>Nombre</th>
                            <th>Teléfono</th>
                            <th>Correo elecrónico</th>
                            <th>Cargo</th>
                            </tr>
                        </thead>
                    </Table>
                    {/* PAGINACIÓN */}
                    <div className="d-flex justify-content-between p-3">
                        <Button
                            variant="outline-primary"
                            disabled={pageCont === 1}
                            onClick={() => setPageCont(pageCont - 1)}
                        >
                            ← Anterior
                        </Button>

                        <span>Página {pageCont}</span>

                        <Button
                            variant="outline-primary"
                            onClick={() => setPageCont(pageCont + 1)}
                        >
                            Siguiente →
                        </Button>
                    </div>                    
                </>
            )}                
        </Card>
        )}
      </div>
    )
}